module.exports = __webpack_public_path__ + "img/request.82385f83.svg";